/**
 * Shared configuration for search result highlighting
 */

// DOMPurify configuration for sanitizing highlighted HTML
export const DOMPURIFY_CONFIG = {
  ALLOWED_TAGS: ['mark'],
  ALLOWED_ATTR: [],
  KEEP_CONTENT: true,
}

export const MARK_STYLES = {
  '& mark': {
    backgroundColor: 'yellow.200',
    color: 'gray.900',
    fontWeight: 'semibold',
    padding: '0 2px',
    borderRadius: '2px',
    _dark: {
      backgroundColor: 'yellow.600',
      color: 'gray.50',
    },
  },
}

/**
 * Check if a string contains highlighting markup
 * @param {string} text - Text to check
 * @returns {boolean} True if text contains <mark> tags
 */
export const hasHighlight = text => {
  return text && text.includes('<mark>')
}
